import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "scheduling-dialog-content" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "head" }, [
  /*#__PURE__*/_createVNode("span", null, "设置紧急联系人")
], -1)
const _hoisted_3 = { class: "dialog-body" }
const _hoisted_4 = { class: "repeat-box" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "title" }, "L1紧急联系人：", -1)
const _hoisted_6 = { class: "persons" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "sep" }, "|", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "请选择L1紧急联系人", -1)
const _hoisted_9 = { class: "repeat-box" }
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "title" }, "L2紧急联系人：", -1)
const _hoisted_11 = { class: "persons" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "sep" }, "|", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "请选择L2紧急联系人", -1)
const _hoisted_14 = { class: "repeat-box" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "title" }, "L3紧急联系人：", -1)
const _hoisted_16 = { class: "persons" }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "sep" }, "|", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "请选择L3紧急联系人", -1)
const _hoisted_19 = { class: "dialog-footer" }
const _hoisted_20 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("确 定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_SchedulingPersonSelect = _resolveComponent("SchedulingPersonSelect")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "close-on-click-modal": false,
    top: 0,
    width: 475,
    "destroy-on-close": "",
    modelValue: _ctx.show,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.show = $event)),
    "show-close": false,
    "custom-class": "scheduling-dialog"
  }, {
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode("div", _hoisted_3, [
          _createVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode("div", _hoisted_6, [
              (_ctx.urgencyDataL1.length > 0)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.urgencyDataL1, (p, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: "person"
                      }, [
                        _createVNode("span", null, _toDisplayString(p.name), 1),
                        _hoisted_7,
                        _createVNode("span", null, _toDisplayString(p.department), 1),
                        _createVNode("i", {
                          onClick: ($event: any) => (_ctx.urgencyDataL1.splice(i, 1)),
                          class: "el-icon-close"
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128)),
                    _createVNode("i", {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL1))),
                      class: "icon-arrow-right"
                    })
                  ], 64))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL1)))
                  }, [
                    _hoisted_8
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode("div", _hoisted_11, [
              (_ctx.urgencyDataL2.length > 0)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.urgencyDataL2, (p, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: "person"
                      }, [
                        _createVNode("span", null, _toDisplayString(p.name), 1),
                        _hoisted_12,
                        _createVNode("span", null, _toDisplayString(p.department), 1),
                        _createVNode("i", {
                          onClick: ($event: any) => (_ctx.urgencyDataL2.splice(i, 1)),
                          class: "el-icon-close"
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128)),
                    _createVNode("i", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL2))),
                      class: "icon-arrow-right"
                    })
                  ], 64))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL2)))
                  }, [
                    _hoisted_13
                  ]))
            ])
          ]),
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, [
              (_ctx.urgencyDataL3.length > 0)
                ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.urgencyDataL3, (p, i) => {
                      return (_openBlock(), _createBlock("div", {
                        key: i,
                        class: "person"
                      }, [
                        _createVNode("span", null, _toDisplayString(p.name), 1),
                        _hoisted_17,
                        _createVNode("span", null, _toDisplayString(p.department), 1),
                        _createVNode("i", {
                          onClick: ($event: any) => (_ctx.urgencyDataL3.splice(i, 1)),
                          class: "el-icon-close"
                        }, null, 8, ["onClick"])
                      ]))
                    }), 128)),
                    _createVNode("i", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL3))),
                      class: "icon-arrow-right"
                    })
                  ], 64))
                : (_openBlock(), _createBlock("div", {
                    key: 1,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showSelectPersonDialog(_ctx.urgencyDataL3)))
                  }, [
                    _hoisted_18
                  ]))
            ])
          ])
        ]),
        _createVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, { onClick: _ctx.cancel }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.submit(_ctx.validScheduleList)))
          }, {
            default: _withCtx(() => [
              _hoisted_21
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_el_dialog, {
          "destroy-on-close": "",
          modelValue: _ctx.showSchedulingPersonSelect,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.showSchedulingPersonSelect = $event)),
          "show-close": false,
          width: 429,
          "custom-class": "person-select-dialog"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_SchedulingPersonSelect, {
              personIds: _ctx.personIdSelectedInit,
              cancel: _ctx.cancelPersonSelect,
              submit: _ctx.submitPersonSelect
            }, null, 8, ["personIds", "cancel", "submit"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}